import { cn } from "../../lib/utils"
import { Button } from "../../components/ui/button"
import { Input } from "../../components/ui/input"
import { Label } from "../../components/ui/label"
import { Link } from "react-router-dom"
import React, { useContext, useState } from "react"
import { AuthContext } from "../../contexts/Auth/Auth.Context"
import axios from "../../utils/axios"
import { REACT_APP_SESSION_DATA } from "../../constants"
import { ErrorAlert } from "../registration/ErrorAlert"
import { Loader2 } from "lucide-react"

interface FormData {
  email: string;
  password: string;
}

export function ForgotPassword({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"form">) {
  const { dispatch } = useContext(AuthContext);

  const [formData, setFormData] = useState<FormData>({ email: "", password: ""});
  const [loading, setLoading] = useState(false);

  const [showError, setShowError] = useState(false);
  const [errorDescription, setErrorDescription] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value}));
    setShowError(false);
  }

  const handleForgotPassword = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);
  }


  return (
    <form onSubmit={handleForgotPassword} className={cn("flex flex-col gap-6", className)} {...props}>
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-2xl font-bold">Forgot your Password?</h1>
        <p className="text-balance text-sm text-muted-foreground">
          We will send a password reset link to your email if it is found in our system.
        </p>
      </div>

      <div className="grid gap-6">
        {showError ? (
            <div className="grid gap-2">
              <ErrorAlert errorDescription={errorDescription} />
            </div>
          ) : null}
        <div className="grid gap-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" name="email" value={formData.email} onChange={handleChange} type="email" placeholder="m@example.com" required />
        </div>

        <Button disabled={loading} type="submit" className="w-full">
          {loading ? <Loader2 className="animate-spin" /> : null}
          Forgot Password
        </Button>

      </div>
      <div className="text-center text-sm">
        Remembered your password?{" "}
        <Link to="/login" className="underline underline-offset-4">
          Login
        </Link>
      </div>
    </form>
  )
}
